import { render, staticRenderFns } from "./Interface.vue?vue&type=template&id=480288f4&scoped=true&"
import script from "./Interface.vue?vue&type=script&lang=js&"
export * from "./Interface.vue?vue&type=script&lang=js&"
import style0 from "./Interface.vue?vue&type=style&index=0&id=480288f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480288f4",
  null
  
)

export default component.exports